import { useCallback, useState } from 'react';
import { LayoutChangeEvent } from 'react-native';

export const useGridInfo = (gridElements: Array<any>) => {
  const [gridContainerWidth, setGridContainerWidth] = useState(0);
  const [gridItemWidth, setGridItemWidth] = useState(0);

  const gridColumnCount =
    gridContainerWidth > 0 && gridItemWidth > 0 ? Math.floor(gridContainerWidth / gridItemWidth) : 0;
  const missingElementCount =
    gridElements.length > gridColumnCount
      ? gridColumnCount > 0
        ? gridElements.length % gridColumnCount
        : 0
      : gridColumnCount - gridElements.length;

  const onGridContainerLayout = useCallback((e: LayoutChangeEvent) => {
    setGridContainerWidth(e.nativeEvent.layout.width);
  }, []);

  const onGridItemLayout = useCallback((e: LayoutChangeEvent) => {
    setGridItemWidth(e.nativeEvent.layout.width);
  }, []);

  return {
    onGridContainerLayout,
    onGridItemLayout,
    missingElementCount,
    gridItemWidth
  };
};
